import { render, staticRenderFns } from "./TenantsView.vue?vue&type=template&id=c03818a8&scoped=true&"
import script from "./TenantsView.vue?vue&type=script&lang=js&"
export * from "./TenantsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03818a8",
  null
  
)

export default component.exports